import { render, staticRenderFns } from "./MarketList.vue?vue&type=template&id=17c8ad59&scoped=true&"
import script from "./MarketList.vue?vue&type=script&lang=js&"
export * from "./MarketList.vue?vue&type=script&lang=js&"
import style0 from "./MarketList.vue?vue&type=style&index=0&id=17c8ad59&scoped=true&lang=css&"
import style1 from "./MarketList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c8ad59",
  null
  
)

export default component.exports